module.exports = __webpack_public_path__ + "static/media/MyPath2ASU_Hero.135d3e44.png";